import { defineComponent as _defineComponent } from 'vue';
import { SGroup, SImageLazy } from '@strana-artw/ui-kit';
import { computed, defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingOffersSlider',
  props: {
    items: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingOffersSlider'
    });
    var swiperOptions = computed(function () {
      return {
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 24,
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove: false,
        direction: 'horizontal',
        breakpoints: {
          0: {
            allowTouchMove: true
          },
          1024: {
            allowTouchMove: false
          }
        }
      };
    });
    return {
      __sfc: true,
      swiperOptions: swiperOptions,
      SGroup: SGroup,
      SImageLazy: SImageLazy
    };
  }
});